import { createFileRoute } from "@tanstack/react-router";
import SportTeamHub from "@/pages/SportTeamHub";
import { MainLayout } from "@/components/layout/MainLayout";
import { socialMeta, readable } from "@/lib/routeSocial";
import { findUsSport } from "@/lib/oddsSports";

export const Route = createFileRoute("/{$sport}-predictions/team/$slug")({
  head: ({ params }) => {
    const sport = findUsSport(params.sport);
    const label = sport?.label ?? readable(params.sport);
    const team = readable(params.slug);
    return {
      meta: socialMeta({
        seo: { topics: [params.sport, "teams"], entities: [readable(params.slug)] },
        title: `${team} Predictions & Odds | ${label} | Statlign`,
        description: `${team} ${label} predictions: next fixtures with model probability, market odds and the value edge on each game.`,
        ...(sport ? { image: `https://statlign.com/og-${sport.slug}.jpg` } : {}),
      }),
    };
  },
  component: () => (
    <MainLayout>
      <SportTeamHub />
    </MainLayout>
  ),
});
